export const getEntityMetaTitle = (titleString) =>
	titleString && `${titleString} | Пушка.рф`;
